import app from 'RootDir/store/modules/app';
import auth from 'RootDir/store/modules/auth';
import user from 'RootDir/store/modules/user';
import loading from 'RootDir/store/modules/loading';
import catalogs from 'RootDir/store/modules/catalogs';
import indPers from 'RootDir/store/modules/individual-persons';
import VuexPersist from 'vuex-persist';

export default {
  modules: {
    app,
    auth,
    user,
    indPers,
    loading,
    catalogs,
  },
  strict: true,
  plugins: [
    new VuexPersist({
      modules: ['auth', 'app', 'user'],
      storage: window.localStorage,
    }).plugin,
  ],
};
